import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  Button,
} from "@mui/material";
import { CardLetterBg } from "../../assets/icons/Icons";
import EditIcon from "@mui/icons-material/Edit";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { useNavigate } from "react-router-dom";
import { AntSwitch, SmallAntSwitch } from "./AntSwitch";

export const ChapterCard = ({
  id,
  word,
  highlightLetter,
  label,
  meaning,
  onEdit,
  onSwitch,
  switchValue,
  handleCardClick,
}) => {
  const [hover, setHover] = React.useState(false);
  const router = useNavigate();
  const location = window.location.pathname.split("/");
  const renderWord = (text, highlightChar) => {
    return text?.split("").map((char, i) => (
      <span
        key={i}
      >
        {char[0]}
      </span>
    ));
  };



  return (
    <Card
      sx={{
        position: "relative",
        borderRadius: "10px",
        width: "100%",
        height: "150px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        cursor: "pointer",
        border: "1px solid #0000000F",
        boxShadow: "1px 2px 4px 0px #00000014",
        transition: "all 0.3s ease-out",
        textDecoration: "none",
        transform: hover ? "scale(1.02)" : "scale(1)",
        "&:hover": {
          transform: "translateY(-1px) scale(1.005) translateZ(0)",
          boxShadow: 3,
        },
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={handleCardClick}
    >
      <Box
        sx={{
          position: "absolute",
          top: "-2px",
          left: "-2px",
          color: "#fff",
          px: 1.5,
          py: 0.5,
          zIndex: 1,
          fontSize: "1rem",
          fontWeight: 500,
          borderBottomRightRadius: "12px",
          textTransform: "uppercase"
        }}
      >
        {renderWord(word[0], highlightLetter)}
        {renderWord(word[word.length - 1], highlightLetter)}
      </Box>

      <Box
        sx={{
          position: "absolute",
          top: "0",
          left: "0",
          zIndex: "0",
          animation: hover ? "patternAnimate 2s infinite linear" : "none",
          "@keyframes patternAnimate": {
            "0%": { transform: "scale(1)" },
            "50%": { transform: "scale(1.1)" },
            "100%": { transform: "scale(1)" },
          },
        }}
      >
        <CardLetterBg />
      </Box>

      <CardContent sx={{ textAlign: "center" }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            color: "#000000ff",
            fontSize: "20px",
            textTransform: "capitalize",
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{ marginTop: "-7px" }}
          variant="body2"
          color="text.secondary"
        >
          {meaning}
        </Typography>
      </CardContent>

      {console.log(switchValue, "switchValue")}
      {location.includes("user") ? null : (
        <SmallAntSwitch
          checked={switchValue} // pass from props or state
          onClick={(e) => e.stopPropagation()} // stop card navigation
          onChange={() => onSwitch?.(id)} // trigger parent handler
          sx={{
            position: "absolute",
            bottom: 8,
            right: 8,
            transform: "scale(1.1)",
          }}
        />
      )}

      {location.includes("user")
        ? null
        : hover && (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onEdit?.(id);
            }}
            sx={{
              position: "absolute",
              top: 0,
              bottom: 0,
              right: 0,
              left: 0,
              bgcolor: "transparent",
              color: "#5F4DA0",
              "&:hover": { bgcolor: "transparent" },
            }}
          >
            <EditIcon />
          </IconButton>
        )}
    </Card>
  );
};
